export default __webpack_public_path__ + "static/media/pdf-logo.14e5592a.jpeg";